import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/sensei_total.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"5px"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "explain" }, [
    /*#__PURE__*/_createTextVNode(" 集計用テンプレート教材（スイートテンプレート）に入力されたデータを、"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("GoogleSpreadSheet™ に展開します。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" データを可視化し、活用することでより理解を深めます。 ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "テンプレートでこども達でも簡単に入力できる"),
  /*#__PURE__*/_createElementVNode("li", null, "入力された意見や実験結果を即座に可視化できる"),
  /*#__PURE__*/_createElementVNode("li", null, "先生が板書する時間を短縮できる"),
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://player.vimeo.com/video/713160254?h=b285ae56c1&autoplay=1&loop=1&title=0&byline=0&portrait=0",
    width: "640",
    height: "360",
    frameborder: "0",
    allow: "autoplay; fullscreen; picture-in-picture",
    allowfullscreen: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://vimeo.com/713160254" }, "先生ツール-製品紹介"),
    /*#__PURE__*/_createTextVNode(" from "),
    /*#__PURE__*/_createElementVNode("a", { href: "https://vimeo.com/zettalinx" }, "ゼッタリンクス"),
    /*#__PURE__*/_createTextVNode(" on "),
    /*#__PURE__*/_createElementVNode("a", { href: "https://vimeo.com" }, "Vimeo"),
    /*#__PURE__*/_createTextVNode(". ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "explain" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" 本アプリケーションはZettaLinxが提供するGoogleSlide™ ,GoogleDocument™ の"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 集計用テンプレート教材（スイートテンプレート）に入力されたデータを収集し、"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" GoogleSpreadSheet™ に展開します。 ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "explain" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" GoogleSpreadSheet™ に出力することより、"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 複数のスイートテンプレートファイルを容易に比較、分析することが可能です。 ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "収集したデータはその場の分析にのみ用い、サーバー上に残すなどはしておりません。"),
  /*#__PURE__*/_createElementVNode("img", {
    draggable: "false",
    src: _imports_0,
    style: {"width":"80%"}
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { style: {} }
const _hoisted_4 = {
  style: {"height":"50%"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-autofit-up",
  width: "22",
  viewBox: "0 0 24 24",
  "stroke-width": "3",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", { d: "M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", { d: "M18 20v-17" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", { d: "M15 6l3 -3l3 3" }, null, -1)
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  style: {"height":"50%"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-autofit-up",
  width: "22",
  viewBox: "0 0 24 24",
  "stroke-width": "3",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", { d: "M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", { d: "M18 20v-17" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", { d: "M15 6l3 -3l3 3" }, null, -1)
const _hoisted_15 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_AppContent = _resolveComponent("AppContent")!

  return (_openBlock(), _createBlock(_component_AppContent, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          onClick: _ctx.toApp,
          type: "fill"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_9)),
            _createTextVNode(" アプリケーションへ移動する ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          onClick: _ctx.toTemplateSite,
          type: "line"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_15)),
            _createTextVNode(" スイートテンプレートを見る ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}